// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__8W5Ii","subscriptionHighlight":"Sidebar_subscriptionHighlight__wnAMp"};